<template>
    <div class="loginverify_wrap">
        <van-nav-bar
                title="REGISTRARSE"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div class="loginverify_top">
            <div class="loginverify_title">Crea una contraseña para tu cuenta</div>
            <div class="loginverify_mobile">
                {{lookmobile}}
            </div>
        </div>

        <div class="loginverify_middle">
            <div class="verifycode_form">
                <div class="verifycode_items border-1">
                    <div class="verifycode_item">
                        <div class="verifycode_ioneleft">
                            <img src="../../assets/img/pwd_suod.webp" />
                        </div>
                        <div class="verifycode_ioneright">
                            <input :type="pwdtype" @input="onSetPassword" v-model="password" placeholder="Crear contraseña de 6 dígitos" >
                        </div>
                        <div class="verifycode_ionecenter" @click.stop="handeleLook">
                            <template v-if="islook">
                                <img src="../../assets/img/pwd_look.webp" />
                            </template>
                            <template v-else>
                                <img src="../../assets/img/pwd_nolook.webp" />
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loginverify_msend_view" v-if="isSendcode">
                <div class="loginverify_msend_mask"></div>
            </div>

        </div>

        <div class="loginverify_footer" style="margin-top: 0;">
            <van-button round color="#19A95C" block style="height: 1.222222rem;" @click="goLogin">
                <span style="font-weight: 500;">CONFIRMAR</span>
            </van-button>
            <div style="width: 100%; height: 10px;"></div>
            <div class="loginverify_password" @click="goToIndex">
                <span>Crea mi contraseña más tarde</span>
            </div>
        </div>
    </div>
</template>

<script>

    import { Toast, Dialog } from 'vant';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getSmscode, loginsms, setPassword } from '@/api/login';

    import { getTimezoneName, getUserIp } from '@/utils/commonParams'

    let clock = null;

    export default{
        data() {
            return {
                fouceIndex: null,
                captchas: [{ num: "" }, { num: "" }, { num: "" }, { num: "" }],
                captchaCode: '',
                password: null,
                mobile: null,
                mobile_exist: false,
                lookmobile: null,
                nums: 60,
                isSendcode: false,
                codeval: '',
                verifyCode: false,
                islook: false,
                pwdtype: 'password',
            }
        },
        mounted() {
            let mobile = this.getQueryString('mobile');
            let mobile_exist = this.getQueryString('mobile_exist');
            let password_exist = this.getQueryString('password_exist');
            console.log(mobile)
            console.log(mobile_exist)
            console.log(password_exist)

            this.mobile_exist = mobile_exist;

            let lookmobile = '+52' + mobile.substring(0, 3)+"****"+mobile.substr(mobile.length-4);

            this.mobile = mobile;
            this.lookmobile = lookmobile;

            let isSendcode = window.localStorage.getItem('isSendcode');

            if(!isSendcode){
                window.localStorage.setItem('isSendcode', true);
            }
        },
        methods: {
            onSetPassword() {
                let getpassword = this.password;
                if(getpassword.length > 6){
                    this.password = getpassword.substr(0, 6);
                }
            },
            handeleLook() {
                this.islook = !this.islook;
                if(this.islook){
                    this.pwdtype = 'text';
                } else {
                    this.pwdtype = 'password';
                }
            },
            goToIndex() {
                this.$router.replace({
                    path: '/loanpage/index',
                });
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    //console.log(column.property)
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                if(sums[4] != 'N/A' && sums[5] != 'N/A'){
                    sums[10] = sums[5]/sums[4] * 100 + '%';
                }

                return sums;
            },
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            goPassword() {
                let usemobile = this.mobile
                this.$router.push({
                    path: '/loanpage/loginpassword',
                    query: {
                        mobile: usemobile
                    }
                })
            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            // 输入框聚焦
            adjust(index) {
                let _this = this;
                console.log(index)
                let dom = document.getElementById("captcha" + this.activeInput);
                if (index != this.activeInput && dom) {
                    dom.focus();
                }
                this.fouceIndex = index;
            },
            // 前后输入方向
            inputDirection(index, event) {
                let value = this.captchas[index].num;
                if (event.keyCode == 8 && value == "") {
                    let dom = document.getElementById("captcha" + (index - 1));
                    this.activeInput = index - 1;
                    if (dom) dom.focus();
                }
                if (event.keyCode != 8 && value != "") {
                    let dom = document.getElementById("captcha" + (index + 1));
                    this.activeInput = index + 1;
                    if (dom) dom.focus();
                }
            },
            // 输入框
            inputFinish(index) {
                let value = this.captchas[index].num;
                this.activeInput = value ? index + 1 : index - 1;
                let dom = document.getElementById("captcha" + this.activeInput);
                if (dom) dom.focus();
                if (index == this.captchas.length - 1) {
                    this.captchaCode = this.captchas.map((a) => a.num).join("");
                    if (this.captchaCode.length == 4) {
                        console.log("captchaCode", this.captchaCode);
                    }
                }
            },
            doLoop() {
                this.nums--;
                if(this.nums > 0){
                    this.codeval = this.nums + 's';
                } else {
                    clearInterval(clock);
                    clock = null;
                    this.isSendcode = false;
                    this.codeval = '';
                    this.nums = 60;
                    window.localStorage.setItem('isSendcode', false);
                }
            },
            commonparamsFun() {
                let commonparams = {
                    aaa_off_csl: '111', //noise
                    zzm_yya_hqb: getAccessToken(), //access_token
                };

                return commonparams;
            },
            async goLogin() {
                let _this = this;
                this.verifyCode = false;
                let commonparams = this.commonparamsFun();
                if(this.password && this.password.length == 6){
                    console.log('验证码输入成功')
                    let usemobile = `+52${this.mobile}`;
                    let usepassword = this.password;

                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        iyc_kae_ixp: usemobile,
                        yyq_wkd_kfd: usepassword,
                        ...commonparams,
                    };

                    console.log(postData)

                    loadingShow();
                    setPassword(postData, {
                        bwd_irh_lnf: time_zone,
                        xfo_plp_van: ip
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                    }, error => {
                        loadingHide()
                    });

                    /*setTimeout(() => {
                        loadingHide();
                        // this.$router.replace({
                        //     path: '/loanpage/index',
                        // })
                        this.$router.back();
                    }, 2000);*/

                } else {
                    Toast('Por favor, cree una contraseña de 6 dígitos') //请输入验证码
                }
            },
        }
    }
</script>

<style less scoped>
    .loginverify_wrap{
        width: 100%;
        height: auto;
    }
    .loginverify_top{
        width: 100%;
        height: 2.722222rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
    }
    .loginverify_title{
        width: 100%;
        height: 0.444444rem;
        font-size: 0.444444rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.444444rem;
        text-align: center;
    }
    .loginverify_mobile{
        width: 100%;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.388889rem;
        text-align: center;
        margin-top: 0.25rem;
    }
    .loginverify_middle{
        width: 92.22%;
        height: auto;
        margin: 0 auto;
    }
    .loginverify_motp{
        width: 100%;
        height: 0.611111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 12px;
    }
    .loginverify_mcode{
        width: 100%;
        height: 1.222222rem;
    }
    .loginverify_mdesc{
        width: 100%;
        height: 0.916667rem;
        font-size: 13px;
        font-weight: 400;
        color: #FB4840;
        line-height: 0.916667rem;
    }
    .loginverify_msend{
        width: 100%;
        height: 1.0rem;
        box-sizing: border-box;
        padding-top: 0.555556rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #333333;
    }
    .loginverify_msend .active{
        color: #333333;
    }
    .loginverify_msend_view{
        width: 100%;
        height: 1px;
        position: relative;
    }
    .loginverify_msend_mask{
        width: 100%;
        height: 1.1rem;
        position: absolute;
        left: 0;
        top: -1rem;
    }
    .loginverify_msend span{
        color: #999999;
        text-decoration: underline;
    }
    .loginverify_footer{
        width: 92.22%;
        height: auto;
        margin: 1.666667rem auto;
    }
    .prize_other_dvview{
        width: 100%;
        height: auto;
        margin: 0 auto;
    }
    .prize_other_inps{
        width: 100%;
    }
    .prize_oinps_view{
        width: 100%;
        height: 1.222222rem;
    }
    .prize_oinps_view input{
        display: block;
        width: 100%;
        height: 1.0rem;
        outline: none;
        background: #DEEEFF;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        padding-left: 0.266667rem;
        font-size: 0.373333rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #954F0A;
    }
    .youxi_form_wrap{
        width: 100%;
        height: 1.25rem;
    }
    .inputBox {
        width: 100%;
        height: 1.222222rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .auth-b {
        width: 1.888889rem;
        height: 1.111111rem;
        box-sizing: border-box;
        border-radius: 0.166667rem;
        border: 1px solid #FFFFFF;
        outline: none;
        line-height: 1.222222rem;
        text-align: center;
        font-size: 0.666667rem;
    }
    .inputBoxview{

    }
    .scale-1px{
        position: relative;
        border:none;
    }
    .scale-1px:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #C7C7C7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-fouce{
        position: relative;
        border:none;
    }
    .scale-1px-fouce:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #19A95C;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .scale-1px-error{
        position: relative;
        border:none;
    }
    .scale-1px-error:after{
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        background: #FB4840;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .inputBoxview .scale-1px:after{
        background: #FB4840;
    }
    .inputBoxview .scale-1px-fouce:after{
        background: #FB4840;
    }
    .loginverify_password{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loginverify_password span{
        font-size: 14px;
        color: #333333;
    }
    .border-1 {
        position: relative;
    }

    .border-1:after {
        content: ' ';
        pointer-events: none;
        box-sizing: border-box;
        -webkit-transform-origin: 0 0;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        /* 多加 0.1%，能解决有时候边框缺失的问题 */
        width: 199.8%;
        height: 199.7%;
        transform: scale(0.5, 0.5);
        border: 0px solid #999999;
        z-index: 2;
    }

    .border-1:after {
        border-width: 1px;
        border-radius: 0.333333rem
    }
    .verifycode_form{
        width: 100%;
        height: 3.75rem;
        margin: 0 auto;
    }
    .verifycode_items{
        width: 100%;
        height: 1.25rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }
    .verifycode_item{
        width: 100%;
        height: 1.25rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .verifycode_ioneleft{
        width: 1.111111rem;
        height: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .verifycode_ioneleft img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .verifycode_ionecenter{
        width: 1.111111rem;
        height: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .verifycode_ionecenter span{
        font-size: 14px;
        color: #000000;
    }
    .verifycode_ionecenter img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .verifycode_ioneright{
        width: 7.2rem;
        height: 1.25rem;
    }
    .verifycode_ioneright input{
        display: block;
        width: 100%;
        height: 1.25rem;
        outline: none;
        border: none;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        background: #ffffff;
        padding: 0;
    }
    input::-webkit-input-placeholder {
        /* WebKit browsers，webkit内核浏览器 */
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input::-moz-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
    input:-ms-input-placeholder {
        color: #CFCFCF;
        font-size: 12px;
    }
</style>

<style less>
    .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>